module.exports = __webpack_public_path__ + "img/programmki.aec4b739.png";